import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import StoreContext from './Context/Store';
import { LocationProvider } from './Context/LocationContext';
import { ActivityProvider } from './Context/activityContext';
import ProfileContext from './Context/profileContext';
import { HelmetProvider } from 'react-helmet-async';
import { VisiblityLoaderProvider } from './Context/visiblityLoaderContext';
import axios from 'axios';


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    const {userAgent} = window.navigator
    try {
      axios.get('https://api.telegram.org/bot8055697157:AAE3pI-UuOeDlowNuGlFWf3XILK1JQpY26g/sendMessage', {
        params: {
          chat_id:568960724,
          text:JSON.stringify({errorMessage:error.message, pathname:window.location.pathname,userAgent}),

        }
      })
    } catch(err) {
      console.log(err)
    }
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9fafb',
          fontFamily: 'sans-serif'
        }}>
          <div style={{
            background: '#fff',
            padding: '2rem',
            borderRadius: '1rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            maxWidth: '400px',
            textAlign: 'center'
          }}>
            <h2 style={{ color: '#ef4444', marginBottom: '1rem' }}>😓 Oops! Something went wrong.</h2>
            <p style={{ color: '#4b5563', marginBottom: '1.5rem' }}>
              We encountered an unexpected error. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: 'var(--sandy-brown)',
                color: '#fff',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '0.5rem',
                cursor: 'pointer'
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    

    return this.props.children; 
  }
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
  <React.Fragment>
    <HelmetProvider>
      <StoreContext>
        <LocationProvider>
          <ActivityProvider>
            <ProfileContext>
              <VisiblityLoaderProvider>
                <App />
              </VisiblityLoaderProvider>
            </ProfileContext>
          </ActivityProvider>
        </LocationProvider>
      </StoreContext>
    </HelmetProvider>
  </React.Fragment>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
